<div class="columns-container">
  <div class="container-02">
    <div class="row v-gutters">
      <div class="col-12 col-md-6" *ngFor="let column of cueElement.elements; trackBy: trackByFnc">
        <sdx-cue-content-portal *ngFor="let e of column.elements; trackBy: trackByFnc" [content]="e"></sdx-cue-content-portal>
      </div>
    </div>
  </div>
